// import React from "react";
// import ReactApexChart from "react-apexcharts";
// import { Box, Typography } from "@mui/material";

// const MonthlySalesChart = () => {
//   const data = {
//     labels: ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
//     sales: [0, 0, 35, 31, 63, 6],
//     revenue: [0, 0, 0, 0, 0, 392]
//   };

//   const chartOptions = {
//     chart: {
//       height: 350,
//       type: "line",
//       toolbar: { show: false }
//     },
//     stroke: {
//       width: [0, 3],
//       curve: "smooth"
//     },
//     dataLabels: {
//       enabled: true,
//       enabledOnSeries: [1]
//     },
//     labels: data.labels,
//     xaxis: {
//       type: "category"
//     },
//     yaxis: [
//       {
//         title: { text: "Sales" }
//       },
//       {
//         opposite: true,
//         title: { text: "Revenue" }
//       }
//     ],
//     tooltip: {
//       shared: true,
//       intersect: false
//     },
//     legend: {
//       position: "top"
//     }
//   };

//   const chartSeries = [
//     {
//       name: "Sales",
//       type: "column",
//       data: data.sales
//     },
//     {
//       name: "Revenue",
//       type: "line",
//       data: data.revenue
//     }
//   ];

//   return (
//     <Box
//       sx={{ p: 3, bgcolor: "background.paper", borderRadius: 3, boxShadow: 3 }}
//     >
//       <Typography
//         variant="h6"
//         sx={{ mb: 2, fontWeight: 600, fontFamily: "Mulish, sans-serif" }}
//       >
//         Monthly Sales & Revenue
//       </Typography>
//       <ReactApexChart
//         options={chartOptions}
//         series={chartSeries}
//         type="line"
//         height={350}
//       />
//     </Box>
//   );
// };

// export default MonthlySalesChart;

import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import { getData } from "../Webservice/Webservice";

const MonthlySalesChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData(
          "dashboard/chart/monthly-sales",
          null,
          token
        );

        if (data && data.success && data.chartData) {
          setChartData(data);
        } else {
          throw new Error("Invalid chart data response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load monthly sales chart data");
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Box
        sx={{
          p: 3,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 350
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Show error state
  if (error) {
    return (
      <Box
        sx={{
          p: 3,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 3
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Box>
    );
  }

  // Show chart when data is available
  if (!chartData) {
    return null;
  }

  const { labels, datasets } = chartData.chartData;

  const chartOptions = {
    chart: {
      height: 350,
      type: "line",
      toolbar: { show: false }
    },
    stroke: {
      width: [0, 3],
      curve: "smooth"
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1]
    },
    labels: labels,
    xaxis: {
      type: "category"
    },
    yaxis: [
      {
        title: { text: "Sales" }
      },
      {
        opposite: true,
        title: { text: "Revenue" }
      }
    ],
    tooltip: {
      shared: true,
      intersect: false
    },
    legend: {
      position: "top"
    }
  };

  const chartSeries = [
    {
      name: datasets[0].label,
      type: "column",
      data: datasets[0].data
    },
    {
      name: datasets[1].label,
      type: "line",
      data: datasets[1].data
    }
  ];

  return (
    <Box
      sx={{ p: 3, bgcolor: "background.paper", borderRadius: 3, boxShadow: 3 }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, fontWeight: 600, fontFamily: "Mulish, sans-serif" }}
      >
        Monthly Sales & Revenue
      </Typography>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </Box>
  );
};

export default MonthlySalesChart;
